import LivestreamVideoPlayer from './LivestreamVideoPlayer';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

LivestreamVideoPlayer.schema = schema;
LivestreamVideoPlayer.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default LivestreamVideoPlayer;

export {
  PLAYLIST_JSON,
  PLAYLIST_DRAFT_JSON,
  OVERLAY_SETTINGS_JSON,
  OVERLAY_SETTINGS_DRAFT_JSON,
  getAssetFolderPath,
  getPlaylistPath,
  getPlaylistDraftPath,
  getOverlaySettingsPath,
  getOverlaySettingsDraftPath
} from './utils/PlaylistUpdater';

export {
  CONTROL_JSON,
  LIVESTREAM_CONTROL_CDN_US,
  LIVESTREAM_CONTROL_CDN_CN,
  LIVESTREAM_CONTROL_PATH_OPTIONS,
  normalizeLivestreamControlPath,
  extractLivestreamControlPathFromUrl,
  getLivestreamControlUrl,
  canonicalizeLivestreamControlUrl,
  withLivestreamControlDefaults,
  rewriteCnLivestreamControlUrlsInHtml,
  normalizeLivestreamSlots,
  normalizeLivestreamWidgetProps,
  rewriteCorruptedLivestreamPollingJsInHtml,
  livestreamWidgetAssetPrefixPattern,
  livestreamControlCdnConstantPattern,
} from './utils/livestreamControl';
